export default __webpack_public_path__ + "static/media/twitter.3972d45f.svg";